export const siteSettings = {
  name: "Quantro EX",
  link: "https://quantroexmarkets.com",
  email: "support@quantroexmarkets.com",
  appLink: "https://app.quantroexmarkets.com",
};
